import axios from "axios";
import { insuranceUrl } from "../constants";
import { ResponseType } from "../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
import {
  PatientFeedbackDetails,
  SubmitPatientFeedbackPayload,
  FeedbackListSearchParams,
  FeedbackListResponse,
} from "./types";

const getBaseURL = () =>
  import.meta.env.MODE === "production"
    ? `${insuranceUrl.startsWith("/") ? location.protocol + "//" + location.host + (window as any)._env_?.VITE_API_URL : insuranceUrl}`
    : `${location.protocol}//${location.host}`;

const createPublicClient = (clinicId?: string | null) => {
  const headers: Record<string, string> = {};
  if (clinicId) {
    headers["X-TenantId"] = clinicId;
  }

  return axios.create({
    baseURL: getBaseURL(),
    headers,
  });
};

export const getPatientFeedbackDetails = async (
  clinicId: string,
): Promise<ResponseType<PatientFeedbackDetails>> => {
  const client = createPublicClient(clinicId);
  const result = await client.get(api.patientFeedbackApi.getDetails, {
    params: { clinicId },
  });
  return result.data;
};

export const getReviewLink = async (
  tenantId: string,
): Promise<ResponseType<string>> => {
  const client = createPublicClient(tenantId);
  const result = await client.get(
    `${api.patientFeedbackApi.reviewLink}${tenantId}`,
    {
      headers: {
        "X-TenantId": tenantId,
      },
    },
  );
  return result.data;
};

export const submitPatientFeedback = async (
  payload: SubmitPatientFeedbackPayload,
): Promise<ResponseType<null>> => {
  const client = createPublicClient(String(payload.clinicId));
  const result = await client.post(
    api.patientFeedbackApi.submitFeedback,
    payload,
  );
  return result.data;
};

export const getAllFeedback = async (
  searchParams: FeedbackListSearchParams,
): Promise<ResponseType<FeedbackListResponse>> => {
  const result = await instance.post(
    api.patientFeedbackApi.getAllFeedback,
    searchParams,
  );
  return result.data;
};

export const sendReviewLink = async ({
  encounterId,
  link,
}: {
  encounterId: number;
  link: string;
}): Promise<ResponseType<null>> => {
  const result = await instance.put(
    `${api.whatsappApi.sendReviewLink}${encounterId}`,
    link,
    {
      headers: {
        "Content-Type": "text/plain",
      },
    },
  );
  return result.data;
};
